"use client";

import React from 'react';
import { Navigate } from 'react-router-dom';

const Index = () => {
  // Redirigir siempre a /radio (Minibid Radio)
  return <Navigate to="/radio" replace />;
};

export default Index;